/* BLACK CLAW — Product Card Image Carousel
   Initializes scroll-snap carousels on product grid cards.
   - Updates dot indicators on scroll
   - Prev/Next arrow buttons (desktop hover)
   - Re-init on Shopify theme editor section reload */
(function () {
  if (window.__bcCardCarouselInit) return;
  window.__bcCardCarouselInit = true;

  function init(carousel) {
    if (carousel.dataset.bcCcReady) return;
    carousel.dataset.bcCcReady = '1';

    var track = carousel.querySelector('.bc-cc__track');
    var dots = carousel.querySelectorAll('.bc-cc__dot');
    var prev = carousel.querySelector('.bc-cc__arrow--prev');
    var next = carousel.querySelector('.bc-cc__arrow--next');
    if (!track) return;

    function update() {
      var w = track.offsetWidth;
      if (w <= 0) return;
      var idx = Math.round(track.scrollLeft / w);
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= dots.length - 1;
    }

    var rafId;
    track.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    }, { passive: true });

    function handleArrow(direction) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        track.scrollBy({ left: direction * track.offsetWidth, behavior: 'smooth' });
      };
    }
    if (prev) prev.addEventListener('click', handleArrow(-1));
    if (next) next.addEventListener('click', handleArrow(1));

    // Stop click bubble when user is mid-swipe so they don't accidentally open PDP
    var touchStartX = 0;
    var touchMoved = false;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchMoved = false;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (Math.abs(e.touches[0].clientX - touchStartX) > 8) touchMoved = true;
    }, { passive: true });
    track.addEventListener('click', function (e) {
      if (touchMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    update();
  }

  function initAll(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.bc-cc');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Re-init when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
